export default "__VITE_ASSET__BI_9sVJ4__"